import * as React from 'react'
import { useStyletron } from 'baseui'
import { getResizeUrl } from '@/utils/getResizeUrl'
import WrapAnimationImage from './WrapAnimationImage'
import { buildMagicTemplateStyle, MagicTemplateStyle } from './MagicTemplatesContent'

export interface MagicTemplateTileItem {
  id: number
  title: string
  prompt: string
  quality: unknown
  model_version: unknown
  assets: { file: string }[]
}

export interface MagicTemplateTileProps {
  item: MagicTemplateTileItem
  categoryId: number
  aspectRatio: number
  onSelectStyle: (style: MagicTemplateStyle) => void
  isLoading?: boolean
  hasPremium?: boolean
  styleIdSelected?: number | null
  showTryAgainOnActive?: boolean
}

/**
 * One selectable template tile. Shared by `MagicTemplatesContent`'s preview
 * rows and any "see all" / single-category grid, so the two don't drift.
 */
export function MagicTemplateTile({
  item,
  categoryId,
  aspectRatio,
  onSelectStyle,
  isLoading = false,
  hasPremium = false,
  styleIdSelected = null,
  showTryAgainOnActive = true,
}: MagicTemplateTileProps) {
  const [css] = useStyletron()
  const resizedBg = getResizeUrl({ size: '360x0', url: item.assets[0].file })
  const resizedFg = getResizeUrl({ size: '360x0', url: item.assets[1].file })

  return (
    <div
      id={String(item.id)}
      className={css({
        position: 'relative',
        width: '92px',
        cursor: isLoading ? 'not-allowed' : 'pointer',
        aspectRatio: aspectRatio < 0.95 ? 2 / 3 : 1,
      })}
    >
      <WrapAnimationImage
        src_bg={resizedBg}
        src_fg={resizedFg}
        handleSelectStyle={() => {
          onSelectStyle(buildMagicTemplateStyle(item, categoryId, aspectRatio))
        }}
        hasPremium={hasPremium}
        imageLoading={isLoading}
        styleIdSelected={styleIdSelected}
        styleId={item.id}
        showTryAgainOnActive={showTryAgainOnActive}
      />
    </div>
  )
}

export default MagicTemplateTile
